import { colors } from "../design-system";
import { AppText } from "./AppText";

/**
 * Repli affiché quand le SDK Google Maps ne se charge pas.
 *
 * Sans lui, l'utilisateur voit le fond gris filigrané de Google — qui se lit
 * comme une app cassée, alors que la cause est presque toujours une clé absente,
 * un référent HTTP non autorisé ou une API non activée. Le message le dit.
 *
 * Partagé par les trois cartes : le même incident doit produire le même écran,
 * qu'on soit en train de choisir une adresse ou de suivre une course.
 */
export function MapUnavailable() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-1 bg-gray-50 px-6 text-center">
      <AppText as="p" variant="labelBold" color={colors.navy800}>
        Carte indisponible
      </AppText>
      <AppText as="p" variant="tiny" color={colors.gray500}>
        La clé Google Maps est absente ou refusée pour ce site.
      </AppText>
    </div>
  );
}
